import React from 'react';
import { useTranslation } from 'react-i18next';
import styled from 'styled-components';
import { themeV2 } from '../styles/themeV2';

const SelectorContainer = styled.div`
  position: relative;
  display: inline-block;
`;

const Select = styled.select`
  background: ${themeV2.colors.white};
  border: 1px solid ${themeV2.colors.slate[200]};
  color: ${themeV2.colors.slate[900]};
  padding: ${themeV2.spacing.sm} ${themeV2.spacing.md};
  border-radius: ${themeV2.borderRadius.xl};
  font-size: ${themeV2.typography.fontSize.sm};
  font-family: ${themeV2.typography.fontFamily.sans.join(', ')};
  cursor: pointer;
  transition: all 0.3s ease;
  min-width: 100px;
  
  &:hover {
    background: ${themeV2.colors.slate[50]};
    border-color: ${themeV2.colors.slate[300]};
  }
  
  &:focus {
    outline: none;
    background: ${themeV2.colors.white};
    border-color: ${themeV2.colors.slate[400]};
    box-shadow: 0 0 0 3px rgba(148, 163, 184, 0.1);
  }
  
  option {
    background: ${themeV2.colors.white};
    color: ${themeV2.colors.slate[900]};
    padding: ${themeV2.spacing.sm};
  }
`;



const LanguageSelector = () => {
  const { i18n, t } = useTranslation();

  const handleLanguageChange = (event) => {
    const selectedLanguage = event.target.value;
    i18n.changeLanguage(selectedLanguage);
  };

  const languages = [
    { code: 'en', name: t('language.english'), flag: '🇺🇸' },
    { code: 'es', name: t('language.spanish'), flag: '🇪🇸' }
  ];

  return (
    <SelectorContainer>
      <Select 
        value={i18n.language} 
        onChange={handleLanguageChange}
        aria-label={t('language.selector')}
      >
        {languages.map((lang) => (
          <option key={lang.code} value={lang.code}>
            {lang.flag} {lang.name}
          </option>
        ))}
      </Select>
    </SelectorContainer>
  );
};

export default LanguageSelector;